import React, { useState, useEffect, useContext } from "react";
import loaderContext from "../../context/loader/LoaderContext";
import { getErrorCodeList } from "../../service/MasterService";
import {
  TroubleShootingStudyCodeColumns,
  TroubleShootingStudyErrorColumns,
} from "./helper/helper";
import { t } from "i18next";
import ListViewV3 from "../../components/ListViewV3/ListViewV3";

const ErrorCodeView = () => {
  const [errorCodeList, setErrorCodeList] = useState([]);
  const [selectedRow, setSelectedRow] = useState(0);
  const [activeDataQuery, setActiveDataQuery] = useState([]);

  const { setLoaderRunning, ref } = useContext(loaderContext);

  const [paginationObj, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [filterObj, setFilterObj] = useState({
    filterInput: null,
    filterUpdate: 0,
  });
  const [sortObj, setSortObj] = useState({
    sortFieldText: "",
    sortFieldValue: "",
    sortDir: false,
    selected: false,
  });

  const fetchData = async () => {
    setLoaderRunning(true);
    ref.current.continuousStart();
    try {
      let data = null;
      let pageCount = null;
      const response = await getErrorCodeList();
      if (response.status === 200 && response.data.result === "SUCCESS") {
        console.log(response.data.data.errorList);
        let results = response.data.data.errorList;
        console.log(results);
        setErrorCodeList(results);
        data = results;
        pageCount = 1;
        setLoaderRunning(false);
        ref.current.complete();
        return {
          rows: data,
          pageCount: pageCount,
        };
      } else {
        setLoaderRunning(false);
        ref.current.complete();
      }
    } catch (e) {
      setLoaderRunning(false);
      ref.current.complete();
    }
  };

  const columns = TroubleShootingStudyCodeColumns(null);

  const handleUserClick = (cell) => {
    console.log("--- This row clicked ----", cell);
    let row = cell.row;
    setSelectedRow(row.index);
  };

  useEffect(() => {
    console.log("Active Query", activeDataQuery);
    if (activeDataQuery != undefined && activeDataQuery.data != undefined) {
      setErrorCodeList(activeDataQuery?.data?.rows);
    }
  }, [activeDataQuery]);

  return (
    <>
      <ListViewV3
        fetchData={fetchData}
        columns={columns}
        handleUserClick={handleUserClick}
        filterObj={filterObj}
        setFilterObj={setFilterObj}
        tabHeaderPresent={true}
        sortObj={sortObj}
        setSortObj={setSortObj}
        setPagination={setPagination}
        paginationObj={paginationObj}
        uniqueKey={"ErrorCode"}
        selectedRow={selectedRow}
        showSideBySide={true}
        setActiveDataQuery={setActiveDataQuery}
        selectedRowComponent={
          <SelectedRowComponent errorCodeList={errorCodeList[selectedRow]} />
        }
        showFilter={false}
        constantFilterHeight={true}
      />
    </>
  );
};

export default ErrorCodeView;

const SelectedRowComponent = ({ errorCodeList }) => {
  if (errorCodeList == undefined) {
    return (
      <>
        <div className="list-view-no-details-found">
          <p className="study-list-no-data-txt">No Details Found</p>
        </div>
      </>
    );
  }

  const style = {
    main: {
      margin: "30px 34px",
      fontFamily: "Open Sans",
      fontStyle: "normal",
    },
    box: {
      marginBottom: "25px",
    },
    label: {
      color: "#494949",
      fontWeight: "600",
      fontSize: "16px",
      lineHeight: "24px",
      display: "flex",
      alignItems: "flex-end",
      paddingBottom: "10px",
    },
    content: {
      color: "#FAFAFA",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "22px",
    },
  };

  return (
    <>
      <div className="tab-section">
        <section className="sectionA">
          <p
            style={{
              fontSize: "20px",
              fontWeight: "600",
              padding: "0px 8px",
              margin: "10px 0px",
            }}
          >
            {t("error-study-list.error-study-details")}
          </p>
        </section>
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
            <div className="ms-Grid-col">
              <div className="form-heading">{t("error-code-list.reason")}</div>
              <div className="form-mt-10">{errorCodeList.reasonOfError}</div>
            </div>
          </div>
          <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
            <div className="ms-Grid-col">
              <div className="form-heading">{t("error-code-list.action")}</div>
              <div className="form-mt-10">{errorCodeList.action}</div>
            </div>
          </div>
          <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
            <div className="ms-Grid-col ">
              <div className="form-heading">{t("error-code-list.corrective")}</div>
              <div className="form-mt-10">{errorCodeList.correctiveAction}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
